<template>
    <div>
        <BackButton />
        <div class="tw-flex tw-flex-wrap">
            <div class="tw-w-full">
                <v-tabs
                    centered
                    grow
                    class="w-100"
                    :color="studio.webAppFontColor"
                >
                    <v-tab
                        @click="selectedView = 'class'"
                        class="flex-grow-1 tw-normal-case tw-font-normal"
                    >
                        {{ $t('message.myClasses') }}
                    </v-tab>
                    <v-tab
                        @click="selectedView = 'course'"
                        class="flex-grow-1 tw-normal-case tw-font-normal"
                    >
                        {{ $t('message.myCourses') }}
                    </v-tab>
                </v-tabs>
            </div>
        </div>
        <CategorizedViewWrapper
            :familyAccounts="familyAccounts"
            :filterAccountLabel="$t('message.filterByAttendee')"
            :tabs="currentTabs"
            @selectAccount="onSelectAccount"
        >
            <template v-slot="{ category }">
                <ClassTable
                    :selectedView="selectedView"
                    :selectedTab="category"
                    :accounts="familyAccounts"
                    :selectedAccountId="selectedAccount?.id"
                />
            </template>
        </CategorizedViewWrapper>
    </div>
</template>
<script>
import BackButton from '@/components/shared/BackButton.vue'
import ClassTable from '@/components/myclasses/ClassTable.vue'
import CategorizedViewWrapper from '@/components/shared/CategorizedViewWrapper.vue'
import { mapGetters } from 'vuex'
import {
    STUDIO_MODULE_NAME,
    AUTHENTICATION_MODULE_NAME,
} from '@/store/moduleNames'
import { fetchSubAccounts } from '@/modules/subAccounts/api/subAccountsApi'
export default {
    components: {
        BackButton,
        ClassTable,
        CategorizedViewWrapper,
    },
    data() {
        return {
            selectedView: 'class',
            selectedAccount: null,
            familyAccounts: [],
            loading: false,
            classTabs: [
                {
                    label: 'message.classesUpcoming',
                    value: 'upcoming',
                },
                {
                    label: 'message.waitlist',
                    value: 'waitlist',
                },
                {
                    label: 'message.classesPast',
                    value: 'past',
                },
                {
                    label: 'message.classesCancelled',
                    value: 'cancelled',
                },
            ],
            courseTabs: [
                {
                    label: 'message.coursesUpcoming',
                    value: 'upcoming',
                },
                {
                    label: 'message.coursesPast',
                    value: 'past',
                },
            ],
        }
    },
    computed: {
        ...mapGetters({
            studio: `${STUDIO_MODULE_NAME}/getStudio`,
            user: `${AUTHENTICATION_MODULE_NAME}/getUser`,
        }),
        activeTabStyle() {
            return {
                backgroundColor: `${this.studio.primaryColor}2e`,
                fontWeight: 'bold',
            }
        },
        subAccounts() {
            if (this.familyAccounts.length > 1) {
                return this.familyAccounts.slice(1)
            }
            return []
        },
        currentTabs() {
            if (this.selectedView === 'class') {
                return this.classTabs.filter((tab) => {
                    // Only show waitlist tab if the selected account is main account
                    if (tab.value === 'waitlist') {
                        return this.selectedAccount?.id === this.user.id
                    }
                    return true
                })
            }
            return this.courseTabs
        },
    },
    created() {
        this.getAccounts()
    },
    methods: {
        async getAccounts() {
            this.loading = true
            if (!this.user) return
            const result = await fetchSubAccounts(this.user.id)
            if (result.success) {
                const { user, subAccounts } = result.data
                this.familyAccounts = [user, ...subAccounts]
                this.selectedAccount = this.familyAccounts[0]
            }
            this.loading = false
        },
        onSelectAccount(account) {
            this.selectedAccount = account
        },
    },
}
</script>
